import React from "react";
import { format } from "date-fns";

const formatDateToBuddhistYear = (dateText) => {
  if (!dateText) return "";
  // console.log(dateText, typeof dateText)
  const date = new Date(dateText);
  // ดึงวันและเดือนจาก date-fns
  const day = format(date, "dd");
  const month = format(date, "MM");
  // ดึงปีและแปลงเป็น พ.ศ.
  const thaiYear = date.getFullYear() + 543;
  return `${day}/${month}/${thaiYear}`;
};

const DatePickerInput = React.forwardRef(({ value, onClick }, ref) => {
  // <i className="icon-calendar"/>  {value}
  //console.log(value)
  return (
    <input
      className="form-control col-sm-12"
      value={formatDateToBuddhistYear(value)}
      onClick={onClick}
      onChange={(e) => {
        /* ใช้ DatePicker จัดการ */
      }}
      style={{
        padding: "8px",
        borderRadius: "4px",
        border: "1px solid #ccc",
        width: "100%",
      }}
    />
  );
});

export default DatePickerInput;
